export const insertSlotManually = (
  containerSelector: string,
  slotAttributeValue: string,
  targetElement?: HTMLElement[] | HTMLElement,
): boolean | undefined => {
  if (!targetElement) {
    return;
  }

  let target;

  if ((targetElement as HTMLElement[]).length) {
    target = targetElement[0] as HTMLElement;
  } else {
    target = targetElement;
  }

  const sourceElement = document.querySelector(containerSelector)?.querySelector(`[slot="${slotAttributeValue}"]`);

  if (!sourceElement) {
    return;
  }

  try {
    target.appendChild(sourceElement.cloneNode(true));

    return true;
  } catch (error) {
    console.error(error);

    return;
  }
};
